$(document).ready(function(){
    $('.slider-slick').slick({
      infinite: true,
      speed: 500,
      slidesToShow: 4, 
      variableWidth: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
    });
});